
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".6","y":".6","width":"22.8","height":"22.8","rx":"11.4","fill":"#FF5050"}}),_c('rect',{attrs:{"x":".6","y":".6","width":"22.8","height":"22.8","rx":"11.4","stroke":"#FF5050","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M11.992 6.166v7m0 4.667h.01","stroke":"#fff","stroke-width":"2.625","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    